import React from "react";

import Context from "../../../context/Context";
import DropdownButton from "../../common/Dropdown/DropdownButton";
import Icons from "../../util/Icons";
import Topic from "../../../context/Topic";
import * as val from "../../../util/val";

const CSS = {
  actionButton: "i-actionbar-button",
  actionButtonCaption: "i-actionbar-button-caption",
  hasFavorite: "i-infopanel-hasfavorite"
};

export class AppLaunch extends React.Component {

  render() {
    const getPlacement = () => {
      if (Context.instance.uiMode.modeIsHorizontalSplit()) {
        return "bottom-end";
      }
    };

    const i18n = Context.instance.i18n;
    const buttonContent = (
      <div>
        {Icons.handleHorizontal()}
        <span className={CSS.actionButtonCaption}>{i18n.general.more}</span>
      </div>
    );

    const options = [];
    this.props.urls.forEach((urlInfo,idx) => {
      let v = val.trim(urlInfo.label);
      if (typeof v !== "string" || v.length === 0) {
        v = i18n.general.untitled;
      }
      let option = (
        <li key={urlInfo.key} role="none">
          <a target="_blank" rel="noopener noreferrer"
            className="i-dd-menuitem"
            role="menuitem link" tabIndex="0"
            href={urlInfo.url} data-i--first={idx===0}>{v}</a>
        </li>
      );
      options.push(option);
    });
    const dropdownContent = (
      <ul role="menu">{options}</ul>
    );

    return (
      <DropdownButton
        closeOnSelect={true}
        focusFirst={true}
        buttonClassName={"i-actionbar-button"}
        contentClassName={"i--applaunch"}
        buttonContent={buttonContent}
        dropdownContent={dropdownContent}
        getPlacement= {getPlacement}>
      </DropdownButton>
    );
  }
}

export class Directions extends React.Component {
  constructor(props) {
    super(props);
    this.clicked = this.clicked.bind(this);
  }

  clicked(event) {
    const searchResult = this.props.item.getSearchResult();
    Topic.publish(Topic.DirectionsClicked,{searchResult: searchResult});
  }

  render() {
    const i18n = Context.getInstance().i18n;
    let className = CSS.actionButton;
    if (this.props.disabled){
      className += " i--disabled";
    }
    const node = (
      <button className={className} onClick={this.clicked}>
        {Icons.directions()}
        <span className={CSS.actionButtonCaption}>{i18n.directions.caption}</span>
      </button>
    );
    return node;
  }
}

export class Launch311 extends React.Component {
  render() {
    const i18n = Context.getInstance().i18n;
    const url = this.props._311Url;
    const node = (
      <a className={CSS.actionButton} href={url} role="button"
        rel="noopener noreferrer" target="_blank">
        {Icons.bell()}
        <span className={CSS.actionButtonCaption}>{i18n.infoPanel.actions.launch311}</span>
      </a>
    );
    return node;
  }
}

export class SaveFavorite extends React.Component {
  constructor(props) {
    super(props);
    this.clicked = this.clicked.bind(this);
  }

  clicked(event) {
    const item = this.props.item;
    const referenceLayer = Context.getInstance().session.referenceLayer;
    referenceLayer.addFavorite(item.getSourceKey(),item.getSearchResult());
  }

  render() {
    const i18n = Context.getInstance().i18n;
    const item = this.props.item;
    const referenceLayer = Context.getInstance().session.referenceLayer;
    const hasFavorite = referenceLayer.hasFavorite(item.getSourceKey(),item.getSearchResult());
    let cls = hasFavorite ? CSS.actionButton + " " + CSS.hasFavorite : CSS.actionButton;
    const tip = hasFavorite ? i18n.infoPanel.actions.tipAlreadySaved : "";
    const caption = hasFavorite ? i18n.infoPanel.actions.savedFavorite : i18n.infoPanel.actions.saveFavorite;
    if (this.props.disabled){
      cls += " i--disabled";
    }
    const node = (
      <button className={cls} title={tip} onClick={this.clicked}>
        {Icons.favorites()}
        <span className={CSS.actionButtonCaption}>{caption}</span>
      </button>
    );
    return node;
  }
}

export class SetHome extends React.Component {
  constructor(props) {
    super(props);
    this.clicked = this.clicked.bind(this);
  }

  clicked(event) {
    const item = this.props.item;
    const referenceLayer = Context.getInstance().session.referenceLayer;
    referenceLayer.setHomeLocation(item.getSourceKey(),item.getSearchResult());
  }

  render() {
    const i18n = Context.getInstance().i18n;
    let className = CSS.actionButton;
    if (this.props.disabled){
      className += " i--disabled";
    }
    const node = (
      <button className={className} onClick={this.clicked}>
        {Icons.home()}
        <span className={CSS.actionButtonCaption}>{i18n.infoPanel.actions.setHome}</span>
      </button>
    );
    return node;
  }
}
